import { Pipe, PipeTransform } from '@angular/core';
import { onlyWhitespace } from '../../helpers/helpers';

@Pipe({
    name: 'onlyWhitespace',
    standalone: true,
})
export class OnlyWhitespacePipe implements PipeTransform {
  transform(text: string): boolean {
    return onlyWhitespace(text)
  }
}